function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M205.103 328.792L95.294 0-129 268.686l334.103 60.106zM1750.66 800.792L1860.46 472l224.3 268.686-334.1 60.106z",
  fill: "#5B5B5B",
  fillOpacity: 0.1
});

function SvgPattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 801,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkyMCIgaGVpZ2h0PSI4MDEiIHZpZXdCb3g9IjAgMCAxOTIwIDgwMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwNS4xMDMgMzI4Ljc5Mkw5NS4yOTQgMEwtMTI5IDI2OC42ODZMMjA1LjEwMyAzMjguNzkyWiIgZmlsbD0iIzVCNUI1QiIgZmlsbC1vcGFjaXR5PSIwLjEiLz4KPHBhdGggZD0iTTE3NTAuNjYgODAwLjc5MkwxODYwLjQ2IDQ3MkwyMDg0Ljc2IDc0MC42ODZMMTc1MC42NiA4MDAuNzkyWiIgZmlsbD0iIzVCNUI1QiIgZmlsbC1vcGFjaXR5PSIwLjEiLz4KPC9zdmc+Cg==";
export { SvgPattern as ReactComponent };